const state = {
  id: undefined,
  artwork_id: undefined,
  assignee_id: undefined,
  completed: false,
  complexity: 1,
  data: {
    provider_id: undefined,
    service_product_id: undefined,
    task_type: '',
  },
  description: '',
  due_date: '',
  hidden: false,
  notes: '',
  notification_emails: [],
  parent_task_id: undefined,
  priority: 'default',
  related_entities_attributes: [],
  sort: undefined,
  status_id: undefined,
  task_list_id: undefined,
  task_list_section_id: undefined,
  task_list_template_item_id: undefined,
  task_type: undefined,
  template_page_ids: [],
  template_page_type: undefined,
  ticketing_system: 'freshdesk',
  ticketing_system_uid: undefined,
  title: '',
  user_id: undefined,
}

export const requiredFields = [
  { key: 'task_list_id' },
  { key: 'task_list_section_id' },
  { key: 'task_type' },
  { key: 'title' },
]

export default state
